import React from 'react'
import "./teamProfilePanel.css"
// import { teamsData } from '../../assets/teams/data';
import { useSelector } from 'react-redux';

const TeamProfilePanel = () => {

    const {
        selectedTeamMember,
        teamsData
    } = useSelector(state => state.service);

    const data = teamsData.find((x, i) => i === selectedTeamMember);

    if (!data) return null;

    const backgroundStyle = {
        backgroundImage: data?.img_src ? `url(${data.img_src})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }

    return (
        <>
            <div className='team-profile-container' style={backgroundStyle}></div>
        </>
    )
}

export default TeamProfilePanel
